import { motion } from "framer-motion";

// Silencio: movimiento lento, suave, sin estridencias.
const ease = [0.22, 1, 0.36, 1];

// Titular que asciende con calma.
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="line-mask">
    <motion.span
      className={"block " + className}
      initial={{ y: "108%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.05, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Aparición suave al entrar en pantalla.
export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.95, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);
